// extracted by mini-css-extract-plugin
module.exports = {"container":"Kontakt_container___cvvC","title":"Kontakt_title__1VFXS","sub":"Kontakt_sub__JejpM","link":"Kontakt_link__2tDLl"};